import { FC } from 'react';
import styled, { css } from 'styled-components';

import { MEDIA_QUERIES } from '#/hooks/useResponsiveValue';
import { CoreFooterFeature } from '#/service/config/features.types';
import { remify } from '#/service/utils';
import { tb } from '#/store/translation/translation.store';

import { FooterLink } from './FooterLink';
import { Logo } from './Logo';

const Container = styled.div<{ $isOneSection: boolean }>`
  padding: 0 ${remify(50)};
  display: flex;
  gap: ${remify(128)};
  ${({ $isOneSection }) =>
    $isOneSection &&
    css`
      @media ${MEDIA_QUERIES.lg} {
        gap: 0;
        flex-direction: column-reverse;
        align-items: center;
        padding-bottom: ${remify(50)};
      }
    `}
`;

const SectionsContainer = styled.div`
  display: inline-block;
  width: 100%;
`;

const LogoContainer = styled.div`
  display: inline-block;
  max-width: 268px;
`;

const Sections = styled.div`
  display: grid;
  grid-auto-flow: column;
`;

const Section = styled.div`
  margin-right: ${remify(32)};
  margin-bottom: ${remify(44)};
`;

const SectionTitle = styled.div`
  font: var(--fontStyleTitle);
  margin-bottom: ${remify(2)};
  display: block;
  color: var(--pageHeadingForeground);
`;

export const FooterSections: FC<Pick<CoreFooterFeature, 'sections'>> = ({
  sections,
}) => (
  <Container $isOneSection={sections.length === 1}>
    <LogoContainer>
      <Logo />
    </LogoContainer>

    <SectionsContainer>
      <Sections>
        {sections.map(({ display, items }) => (
          <Section data-testid="footerSection" key={display.title}>
            <SectionTitle>{tb(display.title)}</SectionTitle>
            {items.map(({ key, ...rest }) => (
              <FooterLink key={key} {...rest} />
            ))}
          </Section>
        ))}
      </Sections>
    </SectionsContainer>
  </Container>
);
